import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
import "@/assets/css/tailwind.css"
import "../node_modules/animate.css"
import "@/assets/css/extend.css"
import VModal from 'vue-js-modal'

Vue.use(VModal);

Vue.config.productionTip = false

var firebaseConfig = {
    apiKey: "AIzaSyBnq6TAri0Dg0qUm2hRfMghkjM3wCWyVjk",
    authDomain: "move-heroes.firebaseapp.com",
    databaseURL: "https://move-heroes.firebaseio.com",
    projectId: "move-heroes",
    storageBucket: "move-heroes.appspot.com",
    messagingSenderId: "638020810469",
    appId: "1:638020810469:web:42513c9a7941540b18c60c",
    measurementId: "G-6Y14V6NBGL"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  firebase.auth().onAuthStateChanged(user => {
    store.dispatch("fetchUser", user);
    store.dispatch("getProfile", user);
  });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
